export default __webpack_public_path__ + "static/investment-grid-background-sea-593a0796fe41ffc818dbe8d89d47addb.jpg";